export default import.meta.ROLLDOWN_FILE_URL_rPEVeO6t9ic9_Oe1zgoLYQ